//list of available filter keys

const filterKeyGameData = {
  SETTLED_AT_START: "settled_at_start",
  SETTLED_AT_END: "settled_at_end",
  GAME_ID: "game_id",
  CATEGORY_ID: "category_id",
};

export { filterKeyGameData };
